import { render, staticRenderFns } from "./ListadoPerseo.vue?vue&type=template&id=5dbdd40a&scoped=true&lang=html"
import script from "./ListadoPerseo.vue?vue&type=script&lang=js"
export * from "./ListadoPerseo.vue?vue&type=script&lang=js"
import style0 from "./ListadoPerseo.vue?vue&type=style&index=0&id=5dbdd40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbdd40a",
  null
  
)

export default component.exports